import { useState, SyntheticEvent } from 'react';
import { Box, Tabs, Tab } from '@mui/material';

import { IDynamicTabPanel } from '../../../../interfaces/dynamic-tab.interface';

const DynamicTabPanel = ({ tabs }: { tabs: IDynamicTabPanel[] }) => {
  const [value, setValue] = useState<number>(0);

  const handleChange = (e: SyntheticEvent, newVal: number) => {
    setValue(newVal);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} variant='scrollable' scrollButtons='auto'>
          {tabs.map((tab: IDynamicTabPanel, index: number) => (
            <Tab key={index} label={tab.label} />
          ))}
        </Tabs>

        {tabs.map((tab: { to?: any; label: any; element?: any }, i: number) => (
          <Box key={i} role='tabpanel' hidden={value !== i}>
            {value === i && <Box>{tab.element}</Box>}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default DynamicTabPanel;
